import { IConfigsType } from '../../types'

const ghaiPopLateNightReport: IConfigsType = {
  ghai_pop: {
    '/:brand/late-night-report': {
      variables: ['date', 'corporateGroup', 'ghaiPopLateNightConfigs'],
      groupFilter: {
        api: 'corporateWithoutBreakdownFilter',
      },
      dateFilter: {
        types: [
          'year',
          'quarter',
          'period',
          'week',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
        defaultType: 'period',
      },
      lateNightReportTitle: {
        type: 'title',
        title: 'Late Night Report',
      },
      filters: {
        type: 'grid',
        children: {
          types: {
            type: 'select',
            value: 'ghaiPopLateNightMetricOptions.value',
            onChange: 'ghaiPopLateNightMetricOptions.onChange',
            options: 'ghaiPopLateNightMetricOptions.options',
            label: 'Metrics',
            width: `400px`,
          },
        },
      },
      downloadCsv: {
        type: 'download-csv',
        api: 'ghaiPopWeekdayAvgLateNight',
        fileName: 'weekday-avg-late-night-report',
        message: 'Download as CSV',
        fields: [
          'groupInfo',
          {
            key: '<%- JSON(ghaiPopLateNightCsvColumns) %>',
            hide: '<%- _.isUndefined(ghaiPopLateNightCsvColumns) %>',
          },
        ],
      },
      lateNightReport: {
        type: 'table-v2',
        api: 'ghaiPopWeekdayAvgLateNight',
        sorting: [
          {
            id: 'location',
            desc: false,
          },
        ],
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup?.tableColumns) %>',
            width: '200px',
            sortable: true,
            fixed: true,
          },
          {
            key: '<%- JSON(ghaiPopLateNightTableColumns.price) %>',
            hide: '<%- _.isUndefined(ghaiPopLateNightTableColumns.price) %>',
          },
          {
            key: '<%- JSON(ghaiPopLateNightTableColumns.percent) %>',
            hide: '<%- _.isUndefined(ghaiPopLateNightTableColumns.percent) %>',
          },
          {
            key: '<%- JSON(ghaiPopLateNightTableColumns.hours) %>',
            hide: '<%- _.isUndefined(ghaiPopLateNightTableColumns.hours) %>',
          },
        ],
      },
    },
  },
}

export default ghaiPopLateNightReport
